import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStrikethroughBox12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconStrikethroughBox12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#StrikethroughBox12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M11.854.854a.5.5 0 0 0-.708-.708l-1.13 1.13A2 2 0 0 0 9 1H3a2 2 0 0 0-2 2v6c0 .37.101.718.277 1.016l-1.13 1.13a.5.5 0 0 0 .707.708l1.13-1.13A2 2 0 0 0 3 11h6a2 2 0 0 0 2-2V3c0-.37-.101-.718-.277-1.016zm-2.595 1.18A1 1 0 0 0 9 2H3a1 1 0 0 0-1 1v6q0 .135.034.259zM2.741 9.966l7.225-7.225Q10 2.866 10 3v6a1 1 0 0 1-1 1H3q-.135 0-.259-.034"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="StrikethroughBox12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconStrikethroughBox12);
